export default {
  field__account_number: 'Account number (IBAN)',
  field__document_type: 'Document type',
  field__document_id: 'Document ID',
  field__account_holder: 'Account holder name',
  field__bank_name: 'Bank name',
  field__bank_code: 'Bank code',
  field__bank_ifsc_code: 'Bank IFSC code',
  field__account_holder_address: 'Account holder address',
  field__bank_address: 'Bank address',
  field__bic: 'BIC',
  field__purpose_of_payment: 'Payment purpose',
  field__pay_id: 'PayID',
  field__card_last_four_digits: 'The last four digits of the card',
  field__invoice_receipt_number: 'Invoice Receipt number',
  field__rif: 'RIF',
  field__phone: 'Phone',
  field__beneficiary: 'Beneficiary',
  field__cbu: 'CBU/CVU',
  field__alias: 'Alias',
};
